// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-47440d3a].newdoctor .vs__dropdown-toggle,[data-v-47440d3a].stateto .vs__dropdown-toggle {\n  padding: 0 !important;\n  height: auto;\n}\n[data-v-47440d3a]#pharmacy-switch.custom-control-input[disabled]\n  ~ .custom-control-label::before,[data-v-47440d3a]#pharmacy-switch.custom-control-input:disabled\n  ~ .custom-control-label::before {\n  background-color: #e4e4e4 !important;\n}\n", ""]);
// Exports
module.exports = exports;
